import template from './offlineModeSelector.html';
import controller from './offlineModeSelector.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    cssClass: '@',
  },
};

export default component;
